<template>
<moo-popover v-if="isLogin" v-model="readVisible" popper-class="read-popper" placement="top-start" width="236" trigger="click">
    <div class="read-info">
      <div class="title">{{$t("当前文档权限为#!!!#src/pages/H5/Cloud/components/tip/read.vue_1")}}{{authInfo}}{{$t("，可向所有者#!!!#src/pages/H5/Cloud/components/tip/read.vue_1")}}</div>
      <div @click="handleClick" class="read-link">{{$t("申请更多权限#!!!#src/pages/H5/Cloud/components/tip/read.vue_1")}}</div>
    </div>
    <div slot="reference" class="file-read">
      {{ authInfo }}
      <svg-icon class="read-arrow-icon" :icon-class="readFileIcon"></svg-icon>
    </div>
  </moo-popover>
  <div v-else class="file-read">
    {{ authInfo }}
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
export default {
  name: "Read",
  data() {
    return {
      // Your data properties go here
      readVisible: false
    };
  },
  props: {
    auth: {
      type: String,
      default: "READ"
    },
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // Your computed properties go here
    authInfo() {
      switch (this.auth) {
        case "READ":
          return intl.$t("仅查看#!!!#src/pages/H5/Cloud/components/tip/read.vue_1");
        case "READ_DOWNLOAD":
          return intl.$t("查看下载#!!!#src/pages/H5/Cloud/components/tip/read.vue_1");
        default:
          return intl.$t("仅查看#!!!#src/pages/H5/Cloud/components/tip/read.vue_2");
      }
    },
    readFileIcon() {
      return this.readVisible ? "read-arrow-up" : "read-arrow-down";
    }
  },
  methods: {
    // Your methods go here
    handleClick() {
      this.readVisible = false;
      this.$emit("applyAuth");
    }
  },
  mounted() {

    // Code to run when the component is mounted goes here
  } };
</script>

<style>
/* Your component-specific styles go here */
.file-read {
  width: auto;
  height: 18px;
  text-align: center;
  line-height: 18px;
  border-radius: 2px;
  font-family: "PingFang SC", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #6c7183;
  letter-spacing: 0;
  padding: 0 4px;
  user-select: none;

  .read-arrow-icon {
    width: 10px;
    height: 10px;
  }

  &:hover {
    cursor: pointer;
    background: #f3f7f9;
  }
}

.read-popper {
  width: unset !important;
  height: 66px;
  background: #ffffff;
  border: 1px solid #e8e9ee;
  box-shadow: 0 8px 16px 0 #1213171a;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px !important;
}

.read-info {
  margin: 0 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  font-family: "PingFang SC", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #222329;
  letter-spacing: 0;
  line-height: 20px;

  .title {
    white-space: nowrap;
  }
}

.read-link {
  color: #5c70ff;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #6d7dff;
  }
}

.popper__arrow {
  display: none !important;
}
</style>
